export default "__VITE_ASSET__DSAhlCr9__"